import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getPresentationValidationOptions,
  useValidatePresentation,
} from '@/module/Author/Presentation/Validation/model/PresentationValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  presentationId: Id;
  variant?: ValidationVariant;
}

export function PresentationValidationAction({ presentationId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getPresentationValidationOptions(presentationId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidatePresentation(presentationId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
